import React from "react";
import { BiSolidFileCss } from "react-icons/bi";
import css from "../assets/CSS.png";
import express from "../assets/Express.png";
import html from "../assets/HTML.png";
import tw from "../assets/Tailwind.png";
import js from "../assets/Javascript.svg";
import mdb from "../assets/MongoDB.svg";
import nodejs from "../assets/NodeJs.svg";
import reactlogo from "../assets/React.png";
import redux from "../assets/Redux.svg";

import { BsChevronDown, BsChevronUp } from "react-icons/bs";

// import { useInView } from "react-intersection-observer";
// import { motion } from "framer-motion";
// import { fadeIn } from "../variants";
import {
  BiCode,
  BiCodeCurly,
  BiLogoCPlusPlus,
  BiLogoJavascript,
  BiLogoReact,
  BiLogoMongodb,
  BiLogoTailwindCss,
  BiLogoNodejs,
  BiLogoGit,
  BiLogoGithub,
  BiLogoHtml5,
  BiLogoCss3,
} from "react-icons/bi";
import { useEffect } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useState } from "react";
import { TbTool } from "react-icons/tb";
import { FaCopyright } from "react-icons/fa";

function Skills() {
  useEffect(() => {
    handlerlib();
    //handletools();
    handlerlang();
  }, []);
  function handlerlang() {
    const langg = document.body.querySelector(".lang");
    // const margin = document.body.querySelector(".vani");

    console.log(langg);

    if (langshower === false) {
      setLangShower(true);
      langg.classList.add("happy");
      langg.classList.remove("hhappy");
    } else {
      setLangShower(false);
      langg.classList.remove("happy");
      langg.classList.add("hhappy");
    }
  }
  function handlerlib() {
    const lang = document.body.querySelector(".lib");

    if (libshower === false) {
      setLibShower(true);
      lang.classList.add("happy");
      lang.classList.remove("hhappy");
    } else {
      setLibShower(false);
      lang.classList.remove("happy");
      lang.classList.add("hhappy");
    }
  }

  const [langshower, setLangShower] = useState(false);
  const [libshower, setLibShower] = useState(true);

  return (
    <div id="Skill" className=" ">
      <section className="section md:mb-32 ">
        <div className="container mx-auto">
          <div className=" flex flex-col justify-center items-center  mt-10 md:mt-28">
            <h1 className=" text-7xl font-Poppinsb  text-accent  font-extrabold  ">
              Skills
            </h1>
            <div>
              <p className="text-[1rem] opacity-75 ">My Technical Skills</p>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row -top-28">
            {/* Description section */}

            <div>
              {/* animation */}
              <div className="pb-20 lg:pb-0 mt-0  mr-0 lg:mr-28 lg:mt-10">
                <div className="circle-animation1 relative w-96 h-96 rounded-full border border-purple-400 grid place-content-center">
                  <div className="icon-rotate absolute w-14 h-14 top-14 right-1">
                    <span className="icon-decor">
                      <img src={reactlogo}></img>
                    </span>
                  </div>
                  <div className="icon-rotate absolute w-14 h-14 bottom-12 right-2 ">
                    <span className="icon-decor">
                      <img src={redux}></img>
                    </span>
                  </div>
                  <div className="icon-rotate absolute w-14 h-14 bottom-1 left-14 bg-none">
                    <span className="icon-decor">
                      <img src={express}></img>
                    </span>
                  </div>
                  <div className="icon-rotate absolute w-14 h-14 -top-2 left-24">
                    <span className="icon-decor">
                      <img src={nodejs}></img>
                    </span>
                  </div>
                  <div className="icon-rotate absolute w-8 h-8 top-32 -left-2">
                    <span className="icon-decor ">
                      <img src={mdb}></img>
                    </span>
                  </div>

                  <div className="circle-animation grid place-content-center w-72 h-72 border-[4rem]  border-purple-300 rounded-full">
                    <div className="relative rounded-full  w-40 h-40 grid place-content-center">
                      <div className="icon-rotate absolute w-10 h-10 right-14 -bottom-5">
                        <span className="icon-decor">
                          <img src={html}></img>
                        </span>
                      </div>
                      <div className="icon-rotate absolute w-10 h-10 top-14 -left-6">
                        <span className="icon-decor">
                          <img src={css}></img>
                        </span>
                      </div>
                      <div className="icon-rotate absolute w-8 h-8 top-14 -right-3">
                        <span className="icon-decor">
                          <img src={js}></img>
                        </span>
                      </div>
                      <div className="icon-rotate absolute w-14 h-14 -top-6 right-14">
                        <span className="icon-decor">
                          <img src={tw}></img>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Skills section */}

            <div className=" flex flex-col md:flex-row justify-center  mx-auto gap-y-14 md:space-x-32 mt-4 ">
              {/* skills-sec-1 */}
              <div className=" flex flex-col space-y-6 ">
                <div
                  className="  flex flex-row relative cursor-pointer  "
                  onClick={handlerlang}
                >
                  <div className="   md:absolute md:top-4 md:-left-10">
                    <BiCode size={30} className="text-deep" />
                  </div>
                  <div className="flex flex-col">
                    <h4 className=" font-bold">Languages</h4>
                    <div className="max-w-[18rem]">
                      <p>Languages that I have picked up over the years</p>
                    </div>
                  </div>
                  <div className=" md:absolute md:-right-7 md:top-4">
                    {langshower ? (
                      <span>
                        {" "}
                        <IoIosArrowUp size={28} className="text-deep" />{" "}
                      </span>
                    ) : (
                      <span>
                        {" "}
                        <IoIosArrowDown size={28} className="text-deep" />{" "}
                      </span>
                    )}
                  </div>
                </div>
                <div className="lang ml-6 md:ml-0  ">
                  <div className="  space-y-9 flex flex-col   ">
                    <div className="w-[18.5rem] relative">
                      <div className=" text-[18px] absolute right-0 -top-4">
                        C
                      </div>
                      <div>
                        <FaCopyright size={28} className="text-deep" />
                      </div>
                      <div className="h-1 bg-deep"></div>
                    </div>
                    <div className="w-[18.5rem] relative">
                      <div className=" text-[18px] absolute right-0 -top-4">
                        Html
                      </div>
                      <div>
                        <BiLogoHtml5 size={28} className="text-deep" />
                      </div>

                      <div className="h-1 bg-deep"></div>
                    </div>
                    <div className="w-[18.5rem] relative">
                      <div className=" text-[18px] absolute right-0 -top-4">
                        Css
                      </div>
                      <div>
                        <BiLogoCss3 size={28} className="text-deep" />
                      </div>
                      <div className="h-1 bg-deep"></div>
                    </div>
                    <div className="w-[18.5rem] relative">
                      <div className=" text-[18px] absolute right-0 -top-4">
                        C++
                      </div>
                      <div>
                        <BiLogoCPlusPlus size={28} className="text-deep" />
                      </div>
                      <div className="h-1 bg-deep"></div>
                    </div>
                    <div className="w-[300px] relative">
                      <div className=" text-[18px] absolute right-0 -top-4">
                        Javascript
                      </div>
                      <div>
                        <BiLogoJavascript size={28} className="text-deep" />
                      </div>
                      <div className="h-1 bg-deep"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* skills-set-2 */}
              <div className=" flex flex-col  space-y-6 ">
                <div
                  className="flex flex-row  relative cursor-pointer  "
                  onClick={handlerlib}
                >
                  <div className=" md:absolute md:top-4 md:-left-12">
                    <BiCodeCurly size={30} className="text-deep" />
                  </div>
                  <div className="flex flex-col">
                    <h4 className=" font-bold">Libraries & Frameworks</h4>
                    <div className="max-w-[18rem]">
                      <p>Libraries and Frameworks that I prefer to work with</p>
                    </div>
                  </div>
                  <div className=" md:absolute md:-right-5 md:top-4">
                    {libshower ? (
                      <span>
                        <IoIosArrowUp size={28} className="text-deep" />{" "}
                      </span>
                    ) : (
                      <span>
                        {" "}
                        <IoIosArrowDown size={28} className="text-deep" />{" "}
                      </span>
                    )}
                  </div>
                </div>
                <div className=" mt-4 lib space-y-9   ml-6 md:ml-0  ">
                  <div className="w-[18.5rem] relative">
                    <div className=" text-[18px] absolute right-0 -top-4">
                      React
                    </div>
                    <div>
                      <BiLogoReact size={28} className="text-deep" />
                    </div>
                    <div className="h-1 bg-deep"></div>
                  </div>
                  <div className="w-[300px] relative">
                    <div className=" text-[18px] absolute right-0 -top-4">
                      Mongodb
                    </div>
                    <div>
                      <BiLogoMongodb size={28} className="text-deep" />
                    </div>
                    <div className="h-1 bg-deep"></div>
                  </div>
                  <div className="w-[300px] relative">
                    <div className=" text-[18px] absolute right-0 -top-4">
                      Node.Js
                    </div>
                    <div>
                      <BiLogoNodejs size={28} className="text-deep" />
                    </div>
                    <div className="h-1 bg-deep"></div>
                  </div>

                  <div className="w-[300px] relative">
                    <div className=" text-[18px] absolute right-0 -top-4">
                      TailwindCss
                    </div>
                    <div>
                      <BiLogoTailwindCss size={28} className="text-deep" />
                    </div>
                    <div className="h-1 bg-deep"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* Skills list */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Skills;
